import { WorldCountry, type Country, type Language } from "./constants.js";

export const countries: Record<Language, Array<Country>> = {
  sv: [
    {
      label: "Sverige",
      value: WorldCountry.SWEDEN,
    },
    {
      label: "Danmark",
      value: WorldCountry.DENMARK,
    },
    {
      label: "Finland",
      value: WorldCountry.FINLAND,
    },
    {
      label: "Island",
      value: WorldCountry.ICELAND,
    },
    {
      label: "Norge",
      value: WorldCountry.NORWAY,
    },
    {
      label: "Afghanistan",
      value: WorldCountry.AFGHANISTAN,
    },
    {
      label: "Albanien",
      value: WorldCountry.ALBANIA,
    },
    {
      label: "Algeriet",
      value: WorldCountry.ALGERIA,
    },
    {
      label: "Amerikanska Samoa",
      value: WorldCountry.AMERICAN_SAMOA,
    },
    {
      label: "Amerikanska Virgin Islands",
      value: WorldCountry.VIRGIN_ISLANDS,
    },
    {
      label: "Amerikas Förenta Stater",
      value: WorldCountry.UNITED_STATES_OF_AMERICA,
    },
    {
      label: "Andorra",
      value: WorldCountry.ANDORRA,
    },
    {
      label: "Angola",
      value: WorldCountry.ANGOLA,
    },
    {
      label: "Anguilla",
      value: WorldCountry.ANGUILLA,
    },
    {
      label: "Antarktis",
      value: WorldCountry.ANTARCTICA,
    },
    {
      label: "Antigua och Barbuda",
      value: WorldCountry.ANTIGUA_AND_BARBUDA,
    },
    {
      label: "Argentina",
      value: WorldCountry.ARGENTINA,
    },
    {
      label: "Armenien",
      value: WorldCountry.ARMENIA,
    },
    {
      label: "Aruba",
      value: WorldCountry.ARUBA,
    },
    {
      label: "Australien",
      value: WorldCountry.AUSTRALIA,
    },
    {
      label: "Azerbadjan",
      value: WorldCountry.AZERBAIJAN,
    },
    {
      label: "Bahamas",
      value: WorldCountry.BAHAMAS,
    },
    {
      label: "Bahrain",
      value: WorldCountry.BAHRAIN,
    },
    {
      label: "Bangladesh",
      value: WorldCountry.BANGLADESH,
    },
    {
      label: "Barbados",
      value: WorldCountry.BARBADOS,
    },
    {
      label: "Belgien",
      value: WorldCountry.BELGIUM,
    },
    {
      label: "Belize",
      value: WorldCountry.BELIZE,
    },
    {
      label: "Benin",
      value: WorldCountry.BENIN,
    },
    {
      label: "Bermuda",
      value: WorldCountry.BERMUDA,
    },
    {
      label: "Bhutan",
      value: WorldCountry.BHUTAN,
    },
    {
      label: "Bolivia",
      value: WorldCountry.BOLIVIA,
    },
    {
      label: "Bonaire, Sint Eustatius och Saba",
      value: WorldCountry.BONAIRE_SINT_EUSTATIUS_AND_SABA,
    },
    {
      label: "Bosnien och Herzegovina",
      value: WorldCountry.BOSNIA_AND_HERZEGOVINA,
    },
    {
      label: "Botswana",
      value: WorldCountry.BOTSWANA,
    },
    {
      label: "Bouvetön",
      value: WorldCountry.BOUVET_ISLAND,
    },
    {
      label: "Brasilien",
      value: WorldCountry.BRAZIL,
    },
    {
      label: "Brittiska Virgin Islands",
      value: WorldCountry.VIRGIN_ISLANDS_BRITISH,
    },
    {
      label: "Brittiska territoriet i Indiska Oceanen",
      value: WorldCountry.BRITISH_INDIAN_OCEAN_TERRITORY,
    },
    {
      label: "Brunei",
      value: WorldCountry.BRUNEI_DARUSSALAM,
    },
    {
      label: "Bulgarien",
      value: WorldCountry.BULGARIA,
    },
    {
      label: "Burkina Faso",
      value: WorldCountry.BURKINA_FASO,
    },
    {
      label: "Burundi",
      value: WorldCountry.BURUNDI,
    },
    {
      label: "Caymanöarna",
      value: WorldCountry.CAYMAN_ISLANDS,
    },
    {
      label: "Centralafrikanska republiken",
      value: WorldCountry.CENTRAL_AFRICAN_REPUBLIC,
    },
    {
      label: "Chile",
      value: WorldCountry.CHILE,
    },
    {
      label: "Cocosöarna",
      value: WorldCountry.COCOS_ISLANDS,
    },
    {
      label: "Colombia",
      value: WorldCountry.COLOMBIA,
    },
    {
      label: "Cooköarna",
      value: WorldCountry.COOK_ISLANDS,
    },
    {
      label: "Costa Rica",
      value: WorldCountry.COSTA_RICA,
    },
    {
      label: "Curaçao",
      value: WorldCountry.CURAÇAO,
    },
    {
      label: "Cypern",
      value: WorldCountry.CYPRUS,
    },
    {
      label: "Demokratiska republiken Kongo",
      value: WorldCountry.CONGO,
    },
    {
      label: "Djibouti",
      value: WorldCountry.DJIBOUTI,
    },
    {
      label: "Dominica",
      value: WorldCountry.DOMINICA,
    },
    {
      label: "Dominikanska republiken",
      value: WorldCountry.DOMINICAN_REPUBLIC,
    },
    {
      label: "Ecuador",
      value: WorldCountry.ECUADOR,
    },
    {
      label: "Egypten",
      value: WorldCountry.EGYPT,
    },
    {
      label: "Ekvatorialguinea",
      value: WorldCountry.EQUATORIAL_GUINEA,
    },
    {
      label: "El Salvador",
      value: WorldCountry.EL_SALVADOR,
    },
    {
      label: "Elfenbenskusten",
      value: WorldCountry.CÔTE_D_IVOIRE,
    },
    {
      label: "Eritrea",
      value: WorldCountry.ERITREA,
    },
    {
      label: "Estland",
      value: WorldCountry.ESTONIA,
    },
    {
      label: "Etiopien",
      value: WorldCountry.ETHIOPIA,
    },
    {
      label: "Falklandsöarna",
      value: WorldCountry.FALKLAND_ISLANDS,
    },
    {
      label: "Fiji",
      value: WorldCountry.FIJI,
    },
    {
      label: "Filippinerna",
      value: WorldCountry.PHILIPPINES,
    },
    {
      label: "Frankrike",
      value: WorldCountry.FRANCE,
    },
    {
      label: "Franska Guyana",
      value: WorldCountry.FRENCH_GUIANA,
    },
    {
      label: "Franska Polynesien",
      value: WorldCountry.FRENCH_POLYNESIA,
    },
    {
      label: "Franska södra territorierna",
      value: WorldCountry.FRENCH_SOUTHERN_TERRITORIES,
    },
    {
      label: "Färöarna",
      value: WorldCountry.FAROE_ISLANDS,
    },
    {
      label: "Förenade Arabemiraten",
      value: WorldCountry.UNITED_ARAB_EMIRATES,
    },
    {
      label: "Förenta staternas mindre öar i Oceanien och Västindien",
      value: WorldCountry.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    },
    {
      label: "Gabon",
      value: WorldCountry.GABON,
    },
    {
      label: "Gambia",
      value: WorldCountry.GAMBIA,
    },
    {
      label: "Georgien",
      value: WorldCountry.GEORGIA,
    },
    {
      label: "Ghana",
      value: WorldCountry.GHANA,
    },
    {
      label: "Gibraltar",
      value: WorldCountry.GIBRALTAR,
    },
    {
      label: "Grekland",
      value: WorldCountry.GREECE,
    },
    {
      label: "Grenada",
      value: WorldCountry.GRENADA,
    },
    {
      label: "Grönland",
      value: WorldCountry.GREENLAND,
    },
    {
      label: "Guadeloupe",
      value: WorldCountry.GUADELOUPE,
    },
    {
      label: "Guam",
      value: WorldCountry.GUAM,
    },
    {
      label: "Guatemala",
      value: WorldCountry.GUATEMALA,
    },
    {
      label: "Guernsey",
      value: WorldCountry.GUERNSEY,
    },
    {
      label: "Guinea",
      value: WorldCountry.GUINEA,
    },
    {
      label: "Guinea-Bissau",
      value: WorldCountry.GUINEA_BISSAU,
    },
    {
      label: "Guyana",
      value: WorldCountry.GUYANA,
    },
    {
      label: "Haiti",
      value: WorldCountry.HAITI,
    },
    {
      label: "Heardöch McDonaldöarna",
      value: WorldCountry.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    },
    {
      label: "Honduras",
      value: WorldCountry.HONDURAS,
    },
    {
      label: "Hongkong",
      value: WorldCountry.HONG_KONG,
    },
    {
      label: "Indien",
      value: WorldCountry.INDIA,
    },
    {
      label: "Indonesien",
      value: WorldCountry.INDONESIA,
    },
    {
      label: "Irak",
      value: WorldCountry.IRAQ,
    },
    {
      label: "Iran",
      value: WorldCountry.IRAN,
    },
    {
      label: "Irland",
      value: WorldCountry.IRELAND,
    },
    {
      label: "Isle of Man",
      value: WorldCountry.ISLE_OF_MAN,
    },
    {
      label: "Israel",
      value: WorldCountry.ISRAEL,
    },
    {
      label: "Italien",
      value: WorldCountry.ITALY,
    },
    {
      label: "Jamaica",
      value: WorldCountry.JAMAICA,
    },
    {
      label: "Japan",
      value: WorldCountry.JAPAN,
    },
    {
      label: "Jemen",
      value: WorldCountry.YEMEN,
    },
    {
      label: "Jersey",
      value: WorldCountry.JERSEY,
    },
    {
      label: "Jordanien",
      value: WorldCountry.JORDAN,
    },
    {
      label: "Julön",
      value: WorldCountry.CHRISTMAS_ISLAND,
    },
    {
      label: "Kambodja",
      value: WorldCountry.CAMBODIA,
    },
    {
      label: "Kamerun",
      value: WorldCountry.CAMEROON,
    },
    {
      label: "Kanada",
      value: WorldCountry.CANADA,
    },
    {
      label: "Kap Verde",
      value: WorldCountry.CABO_VERDE,
    },
    {
      label: "Kazakstan",
      value: WorldCountry.KAZAKHSTAN,
    },
    {
      label: "Kenya",
      value: WorldCountry.KENYA,
    },
    {
      label: "Kina",
      value: WorldCountry.CHINA,
    },
    {
      label: "Kirgisistan",
      value: WorldCountry.KYRGYZSTAN,
    },
    {
      label: "Kiribati",
      value: WorldCountry.KIRIBATI,
    },
    {
      label: "Komorerna",
      value: WorldCountry.COMOROS,
    },
    {
      label: "Kongo",
      value: WorldCountry.CONGO_2,
    },
    {
      label: "Kroatien",
      value: WorldCountry.CROATIA,
    },
    {
      label: "Kuba",
      value: WorldCountry.CUBA,
    },
    {
      label: "Kuwait",
      value: WorldCountry.KUWAIT,
    },
    {
      label: "Laos",
      value: WorldCountry.LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    },
    {
      label: "Lesotho",
      value: WorldCountry.LESOTHO,
    },
    {
      label: "Lettland",
      value: WorldCountry.LATVIA,
    },
    {
      label: "Libanon",
      value: WorldCountry.LEBANON,
    },
    {
      label: "Liberia",
      value: WorldCountry.LIBERIA,
    },
    {
      label: "Libyen",
      value: WorldCountry.LIBYA,
    },
    {
      label: "Liechtenstein",
      value: WorldCountry.LIECHTENSTEIN,
    },
    {
      label: "Litauen",
      value: WorldCountry.LITHUANIA,
    },
    {
      label: "Luxemburg",
      value: WorldCountry.LUXEMBOURG,
    },
    {
      label: "Macao",
      value: WorldCountry.MACAO,
    },
    {
      label: "Madagaskar",
      value: WorldCountry.MADAGASCAR,
    },
    {
      label: "Makedonien",
      value: WorldCountry.REPUBLIC_OF_NORTH_MACEDONIA,
    },
    {
      label: "Malawi",
      value: WorldCountry.MALAWI,
    },
    {
      label: "Malaysia",
      value: WorldCountry.MALAYSIA,
    },
    {
      label: "Maldiverna",
      value: WorldCountry.MALDIVES,
    },
    {
      label: "Mali",
      value: WorldCountry.MALI,
    },
    {
      label: "Malta",
      value: WorldCountry.MALTA,
    },
    {
      label: "Marocko",
      value: WorldCountry.MOROCCO,
    },
    {
      label: "Marshallöarna",
      value: WorldCountry.MARSHALL_ISLANDS,
    },
    {
      label: "Martinique",
      value: WorldCountry.MARTINIQUE,
    },
    {
      label: "Mauretanien",
      value: WorldCountry.MAURITANIA,
    },
    {
      label: "Mauritius",
      value: WorldCountry.MAURITIUS,
    },
    {
      label: "Mayotte",
      value: WorldCountry.MAYOTTE,
    },
    {
      label: "Mexiko",
      value: WorldCountry.MEXICO,
    },
    {
      label: "Mikronesien",
      value: WorldCountry.MICRONESIA,
    },
    {
      label: "Moldavien",
      value: WorldCountry.MOLDOVA,
    },
    {
      label: "Monaco",
      value: WorldCountry.MONACO,
    },
    {
      label: "Mongoliet",
      value: WorldCountry.MONGOLIA,
    },
    {
      label: "Montenegro",
      value: WorldCountry.MONTENEGRO,
    },
    {
      label: "Montserrat",
      value: WorldCountry.MONTSERRAT,
    },
    {
      label: "Moçambique",
      value: WorldCountry.MOZAMBIQUE,
    },
    {
      label: "Myanmar",
      value: WorldCountry.MYANMAR,
    },
    {
      label: "Namibia",
      value: WorldCountry.NAMIBIA,
    },
    {
      label: "Nauru",
      value: WorldCountry.NAURU,
    },
    {
      label: "Nederländerna",
      value: WorldCountry.NETHERLANDS,
    },
    {
      label: "Nederländska Antillerna",
      value: WorldCountry.NETHERLANDS_ANTILLES,
    },
    {
      label: "Nepal",
      value: WorldCountry.NEPAL,
    },
    {
      label: "Nicaragua",
      value: WorldCountry.NICARAGUA,
    },
    {
      label: "Niger",
      value: WorldCountry.NIGER,
    },
    {
      label: "Nigeria",
      value: WorldCountry.NIGERIA,
    },
    {
      label: "Niue",
      value: WorldCountry.NIUE,
    },
    {
      label: "Nordkorea",
      value: WorldCountry.KOREA_NORTH,
    },
    {
      label: "Nordmarianerna",
      value: WorldCountry.NORTHERN_MARIANA_ISLANDS,
    },
    {
      label: "Norfolkön",
      value: WorldCountry.NORFOLK_ISLAND,
    },
    {
      label: "Nya Kaledonien",
      value: WorldCountry.NEW_CALEDONIA,
    },
    {
      label: "Nya Zeeland",
      value: WorldCountry.NEW_ZEALAND,
    },
    {
      label: "Oman",
      value: WorldCountry.OMAN,
    },
    {
      label: "Pakistan",
      value: WorldCountry.PAKISTAN,
    },
    {
      label: "Palau",
      value: WorldCountry.PALAU,
    },
    {
      label: "Palestina",
      value: WorldCountry.PALESTINE,
    },
    {
      label: "Panama",
      value: WorldCountry.PANAMA,
    },
    {
      label: "Papua Nya Guinea",
      value: WorldCountry.PAPUA_NEW_GUINEA,
    },
    {
      label: "Paraguay",
      value: WorldCountry.PARAGUAY,
    },
    {
      label: "Peru",
      value: WorldCountry.PERU,
    },
    {
      label: "Pitcairn",
      value: WorldCountry.PITCAIRN,
    },
    {
      label: "Polen",
      value: WorldCountry.POLAND,
    },
    {
      label: "Portugal",
      value: WorldCountry.PORTUGAL,
    },
    {
      label: "Puerto Rico",
      value: WorldCountry.PUERTO_RICO,
    },
    {
      label: "Qatar",
      value: WorldCountry.QATAR,
    },
    {
      label: "Rumänien",
      value: WorldCountry.ROMANIA,
    },
    {
      label: "Rwanda",
      value: WorldCountry.RWANDA,
    },
    {
      label: "Ryssland",
      value: WorldCountry.RUSSIAN_FEDERATION,
    },
    {
      label: "Réunion",
      value: WorldCountry.RÉUNION,
    },
    {
      label: "Saint Barthélemy",
      value: WorldCountry.SAINT_BARTHÉLEMY,
    },
    {
      label: "Saint Helena",
      value: WorldCountry.SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA,
    },
    {
      label: "Saint Kitts och Nevis",
      value: WorldCountry.SAINT_KITTS_AND_NEVIS,
    },
    {
      label: "Saint Lucia",
      value: WorldCountry.SAINT_LUCIA,
    },
    {
      label: "Saint Pierre och Miquelon",
      value: WorldCountry.SAINT_PIERRE_AND_MIQUELON,
    },
    {
      label: "Saint Vincent och Grenadinerna",
      value: WorldCountry.SAINT_VINCENT_AND_THE_GRENADINES,
    },
    {
      label: "Saint-Martin",
      value: WorldCountry.SAINT_MARTIN,
    },
    {
      label: "Salomonöarna",
      value: WorldCountry.SOLOMON_ISLANDS,
    },
    {
      label: "Samoa",
      value: WorldCountry.SAMOA,
    },
    {
      label: "San Marino",
      value: WorldCountry.SAN_MARINO,
    },
    {
      label: "Saudiarabien",
      value: WorldCountry.SAUDI_ARABIA,
    },
    {
      label: "Schweiz",
      value: WorldCountry.SWITZERLAND,
    },
    {
      label: "Senegal",
      value: WorldCountry.SENEGAL,
    },
    {
      label: "Serbien",
      value: WorldCountry.SERBIA,
    },
    {
      label: "Seychellerna",
      value: WorldCountry.SEYCHELLES,
    },
    {
      label: "Sierra Leone",
      value: WorldCountry.SIERRA_LEONE,
    },
    {
      label: "Singapore",
      value: WorldCountry.SINGAPORE,
    },
    {
      label: "Sint Maarten (nederländska delen)",
      value: WorldCountry.SINT_MAARTEN,
    },
    {
      label: "Slovakien",
      value: WorldCountry.SLOVAKIA,
    },
    {
      label: "Slovenien",
      value: WorldCountry.SLOVENIA,
    },
    {
      label: "Somalia",
      value: WorldCountry.SOMALIA,
    },
    {
      label: "Spanien",
      value: WorldCountry.SPAIN,
    },
    {
      label: "Sri Lanka",
      value: WorldCountry.SRI_LANKA,
    },
    {
      label: "Storbritannien",
      value: WorldCountry.UNITED_KINGDOM_OF_GREAT_BRITAIN_AND_NORTHERN_IRELAND,
    },
    {
      label: "Sudan",
      value: WorldCountry.SUDAN,
    },
    {
      label: "Surinam",
      value: WorldCountry.SURINAME,
    },
    {
      label: "Svalbard och Jan Mayen",
      value: WorldCountry.SVALBARD_AND_JAN_MAYEN,
    },
    {
      label: "Swaziland",
      value: WorldCountry.ESWATINI,
    },
    {
      label: "Sydafrika",
      value: WorldCountry.SOUTH_AFRICA,
    },
    {
      label: "Sydgeorgien och Sydsandwichöarna",
      value: WorldCountry.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    },
    {
      label: "Sydkorea",
      value: WorldCountry.KOREA_SOUTH,
    },
    {
      label: "Sydsudan",
      value: WorldCountry.SOUTH_SUDAN,
    },
    {
      label: "Syrien",
      value: WorldCountry.SYRIAN_ARAB_REPUBLIC,
    },
    {
      label: "São Tomé och Príncipe",
      value: WorldCountry.SAO_TOME_AND_PRINCIPE,
    },
    {
      label: "Tadzjikistan",
      value: WorldCountry.TAJIKISTAN,
    },
    {
      label: "Taiwan",
      value: WorldCountry.TAIWAN,
    },
    {
      label: "Tanzania",
      value: WorldCountry.TANZANIA_UNITED_REPUBLIC_OF,
    },
    {
      label: "Tchad",
      value: WorldCountry.CHAD,
    },
    {
      label: "Thailand",
      value: WorldCountry.THAILAND,
    },
    {
      label: "Timor-Leste",
      value: WorldCountry.TIMOR_LESTE,
    },
    {
      label: "Tjeckiska republiken",
      value: WorldCountry.CZECHIA,
    },
    {
      label: "Togo",
      value: WorldCountry.TOGO,
    },
    {
      label: "Tokelau",
      value: WorldCountry.TOKELAU,
    },
    {
      label: "Tonga",
      value: WorldCountry.TONGA,
    },
    {
      label: "Trinidad och Tobago",
      value: WorldCountry.TRINIDAD_AND_TOBAGO,
    },
    {
      label: "Tunisien",
      value: WorldCountry.TUNISIA,
    },
    {
      label: "Turkiet",
      value: WorldCountry.TURKEY,
    },
    {
      label: "Turkmenistan",
      value: WorldCountry.TURKMENISTAN,
    },
    {
      label: "Turks- och Caicosöarna",
      value: WorldCountry.TURKS_AND_CAICOS_ISLANDS,
    },
    {
      label: "Tuvalu",
      value: WorldCountry.TUVALU,
    },
    {
      label: "Tyskland",
      value: WorldCountry.GERMANY,
    },
    {
      label: "Uganda",
      value: WorldCountry.UGANDA,
    },
    {
      label: "Ukraina",
      value: WorldCountry.UKRAINE,
    },
    {
      label: "Ungern",
      value: WorldCountry.HUNGARY,
    },
    {
      label: "Uruguay",
      value: WorldCountry.URUGUAY,
    },
    {
      label: "Uzbekistan",
      value: WorldCountry.UZBEKISTAN,
    },
    {
      label: "Vanuatu",
      value: WorldCountry.VANUATU,
    },
    {
      label: "Vatikanen",
      value: WorldCountry.HOLY_SEE,
    },
    {
      label: "Venezuela",
      value: WorldCountry.VENEZUELA,
    },
    {
      label: "Vietnam",
      value: WorldCountry.VIET_NAM,
    },
    {
      label: "Vitryssland",
      value: WorldCountry.BELARUS,
    },
    {
      label: "Västra Sahara",
      value: WorldCountry.WESTERN_SAHARA,
    },
    {
      label: "Wallis och Futuna",
      value: WorldCountry.WALLIS_AND_FUTUNA,
    },
    {
      label: "Zambia",
      value: WorldCountry.ZAMBIA,
    },
    {
      label: "Zimbabwe",
      value: WorldCountry.ZIMBABWE,
    },
    {
      label: "Åland",
      value: WorldCountry.ÅLAND_ISLANDS,
    },
    {
      label: "Österrike",
      value: WorldCountry.AUSTRIA,
    },
  ],
  en: [
    {
      label: "Afghanistan",
      value: WorldCountry.AFGHANISTAN,
    },
    {
      label: "Albania",
      value: WorldCountry.ALBANIA,
    },
    {
      label: "Algeria",
      value: WorldCountry.ALGERIA,
    },
    {
      label: "American Samoa",
      value: WorldCountry.AMERICAN_SAMOA,
    },
    {
      label: "Andorra",
      value: WorldCountry.ANDORRA,
    },
    {
      label: "Angola",
      value: WorldCountry.ANGOLA,
    },
    {
      label: "Anguilla",
      value: WorldCountry.ANGUILLA,
    },
    {
      label: "Antarctica",
      value: WorldCountry.ANTARCTICA,
    },
    {
      label: "Antigua and Barbuda",
      value: WorldCountry.ANTIGUA_AND_BARBUDA,
    },
    {
      label: "Argentina",
      value: WorldCountry.ARGENTINA,
    },
    {
      label: "Armenia",
      value: WorldCountry.ARMENIA,
    },
    {
      label: "Aruba",
      value: WorldCountry.ARUBA,
    },
    {
      label: "Australia",
      value: WorldCountry.AUSTRALIA,
    },
    {
      label: "Austria",
      value: WorldCountry.AUSTRIA,
    },
    {
      label: "Azerbaijan",
      value: WorldCountry.AZERBAIJAN,
    },
    {
      label: "Bahamas (the)",
      value: WorldCountry.BAHAMAS,
    },
    {
      label: "Bahrain",
      value: WorldCountry.BAHRAIN,
    },
    {
      label: "Bangladesh",
      value: WorldCountry.BANGLADESH,
    },
    {
      label: "Barbados",
      value: WorldCountry.BARBADOS,
    },
    {
      label: "Belarus",
      value: WorldCountry.BELARUS,
    },
    {
      label: "Belgium",
      value: WorldCountry.BELGIUM,
    },
    {
      label: "Belize",
      value: WorldCountry.BELIZE,
    },
    {
      label: "Benin",
      value: WorldCountry.BENIN,
    },
    {
      label: "Bermuda",
      value: WorldCountry.BERMUDA,
    },
    {
      label: "Bhutan",
      value: WorldCountry.BHUTAN,
    },
    {
      label: "Bolivia (Plurinational State of)",
      value: WorldCountry.BOLIVIA,
    },
    {
      label: "Bonaire, Sint Eustatius and Saba",
      value: WorldCountry.BONAIRE_SINT_EUSTATIUS_AND_SABA,
    },
    {
      label: "Bosnia and Herzegovina",
      value: WorldCountry.BOSNIA_AND_HERZEGOVINA,
    },
    {
      label: "Botswana",
      value: WorldCountry.BOTSWANA,
    },
    {
      label: "Bouvet Island",
      value: WorldCountry.BOUVET_ISLAND,
    },
    {
      label: "Brazil",
      value: WorldCountry.BRAZIL,
    },
    {
      label: "British Indian Ocean Territory (the)",
      value: WorldCountry.BRITISH_INDIAN_OCEAN_TERRITORY,
    },
    {
      label: "Brunei Darussalam",
      value: WorldCountry.BRUNEI_DARUSSALAM,
    },
    {
      label: "Bulgaria",
      value: WorldCountry.BULGARIA,
    },
    {
      label: "Burkina Faso",
      value: WorldCountry.BURKINA_FASO,
    },
    {
      label: "Burundi",
      value: WorldCountry.BURUNDI,
    },
    {
      label: "Cabo Verde",
      value: WorldCountry.CABO_VERDE,
    },
    {
      label: "Cambodia",
      value: WorldCountry.CAMBODIA,
    },
    {
      label: "Cameroon",
      value: WorldCountry.CAMEROON,
    },
    {
      label: "Canada",
      value: WorldCountry.CANADA,
    },
    {
      label: "Cayman Islands (the)",
      value: WorldCountry.CAYMAN_ISLANDS,
    },
    {
      label: "Central African Republic (the)",
      value: WorldCountry.CENTRAL_AFRICAN_REPUBLIC,
    },
    {
      label: "Chad",
      value: WorldCountry.CHAD,
    },
    {
      label: "Chile",
      value: WorldCountry.CHILE,
    },
    {
      label: "China",
      value: WorldCountry.CHINA,
    },
    {
      label: "Christmas Island",
      value: WorldCountry.CHRISTMAS_ISLAND,
    },
    {
      label: "Cocos (Keeling) Islands (the)",
      value: WorldCountry.COCOS_ISLANDS,
    },
    {
      label: "Colombia",
      value: WorldCountry.COLOMBIA,
    },
    {
      label: "Comoros (the)",
      value: WorldCountry.COMOROS,
    },
    {
      label: "Congo (the Democratic Republic of the)",
      value: WorldCountry.CONGO,
    },
    {
      label: "Congo (the)",
      value: WorldCountry.CONGO_2,
    },
    {
      label: "Cook Islands (the)",
      value: WorldCountry.COOK_ISLANDS,
    },
    {
      label: "Costa Rica",
      value: WorldCountry.COSTA_RICA,
    },
    {
      label: "Croatia",
      value: WorldCountry.CROATIA,
    },
    {
      label: "Cuba",
      value: WorldCountry.CUBA,
    },
    {
      label: "Curaçao",
      value: WorldCountry.CURAÇAO,
    },
    {
      label: "Cyprus",
      value: WorldCountry.CYPRUS,
    },
    {
      label: "Czechia",
      value: WorldCountry.CZECHIA,
    },
    {
      label: "Côte d'Ivoire",
      value: WorldCountry.CÔTE_D_IVOIRE,
    },
    {
      label: "Denmark",
      value: WorldCountry.DENMARK,
    },
    {
      label: "Djibouti",
      value: WorldCountry.DJIBOUTI,
    },
    {
      label: "Dominica",
      value: WorldCountry.DOMINICA,
    },
    {
      label: "Dominican Republic (the)",
      value: WorldCountry.DOMINICAN_REPUBLIC,
    },
    {
      label: "Ecuador",
      value: WorldCountry.ECUADOR,
    },
    {
      label: "Egypt",
      value: WorldCountry.EGYPT,
    },
    {
      label: "El Salvador",
      value: WorldCountry.EL_SALVADOR,
    },
    {
      label: "Equatorial Guinea",
      value: WorldCountry.EQUATORIAL_GUINEA,
    },
    {
      label: "Eritrea",
      value: WorldCountry.ERITREA,
    },
    {
      label: "Estonia",
      value: WorldCountry.ESTONIA,
    },
    {
      label: "Eswatini",
      value: WorldCountry.ESWATINI,
    },
    {
      label: "Ethiopia",
      value: WorldCountry.ETHIOPIA,
    },
    {
      label: "Falkland Islands (the) [Malvinas]",
      value: WorldCountry.FALKLAND_ISLANDS,
    },
    {
      label: "Faroe Islands (the)",
      value: WorldCountry.FAROE_ISLANDS,
    },
    {
      label: "Fiji",
      value: WorldCountry.FIJI,
    },
    {
      label: "Finland",
      value: WorldCountry.FINLAND,
    },
    {
      label: "France",
      value: WorldCountry.FRANCE,
    },
    {
      label: "French Guiana",
      value: WorldCountry.FRENCH_GUIANA,
    },
    {
      label: "French Polynesia",
      value: WorldCountry.FRENCH_POLYNESIA,
    },
    {
      label: "French Southern Territories (the)",
      value: WorldCountry.FRENCH_SOUTHERN_TERRITORIES,
    },
    {
      label: "Gabon",
      value: WorldCountry.GABON,
    },
    {
      label: "Gambia (the)",
      value: WorldCountry.GAMBIA,
    },
    {
      label: "Georgia",
      value: WorldCountry.GEORGIA,
    },
    {
      label: "Germany",
      value: WorldCountry.GERMANY,
    },
    {
      label: "Ghana",
      value: WorldCountry.GHANA,
    },
    {
      label: "Gibraltar",
      value: WorldCountry.GIBRALTAR,
    },
    {
      label: "Greece",
      value: WorldCountry.GREECE,
    },
    {
      label: "Greenland",
      value: WorldCountry.GREENLAND,
    },
    {
      label: "Grenada",
      value: WorldCountry.GRENADA,
    },
    {
      label: "Guadeloupe",
      value: WorldCountry.GUADELOUPE,
    },
    {
      label: "Guam",
      value: WorldCountry.GUAM,
    },
    {
      label: "Guatemala",
      value: WorldCountry.GUATEMALA,
    },
    {
      label: "Guernsey",
      value: WorldCountry.GUERNSEY,
    },
    {
      label: "Guinea",
      value: WorldCountry.GUINEA,
    },
    {
      label: "Guinea-Bissau",
      value: WorldCountry.GUINEA_BISSAU,
    },
    {
      label: "Guyana",
      value: WorldCountry.GUYANA,
    },
    {
      label: "Haiti",
      value: WorldCountry.HAITI,
    },
    {
      label: "Heard Island and McDonald Islands",
      value: WorldCountry.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    },
    {
      label: "Holy See (the)",
      value: WorldCountry.HOLY_SEE,
    },
    {
      label: "Honduras",
      value: WorldCountry.HONDURAS,
    },
    {
      label: "Hong Kong",
      value: WorldCountry.HONG_KONG,
    },
    {
      label: "Hungary",
      value: WorldCountry.HUNGARY,
    },
    {
      label: "Iceland",
      value: WorldCountry.ICELAND,
    },
    {
      label: "India",
      value: WorldCountry.INDIA,
    },
    {
      label: "Indonesia",
      value: WorldCountry.INDONESIA,
    },
    {
      label: "Iran (Islamic Republic of)",
      value: WorldCountry.IRAN,
    },
    {
      label: "Iraq",
      value: WorldCountry.IRAQ,
    },
    {
      label: "Ireland",
      value: WorldCountry.IRELAND,
    },
    {
      label: "Isle of Man",
      value: WorldCountry.ISLE_OF_MAN,
    },
    {
      label: "Israel",
      value: WorldCountry.ISRAEL,
    },
    {
      label: "Italy",
      value: WorldCountry.ITALY,
    },
    {
      label: "Jamaica",
      value: WorldCountry.JAMAICA,
    },
    {
      label: "Japan",
      value: WorldCountry.JAPAN,
    },
    {
      label: "Jersey",
      value: WorldCountry.JERSEY,
    },
    {
      label: "Jordan",
      value: WorldCountry.JORDAN,
    },
    {
      label: "Kazakhstan",
      value: WorldCountry.KAZAKHSTAN,
    },
    {
      label: "Kenya",
      value: WorldCountry.KENYA,
    },
    {
      label: "Kiribati",
      value: WorldCountry.KIRIBATI,
    },
    {
      label: "Korea (the Democratic People's Republic of)",
      value: WorldCountry.KOREA_NORTH,
    },
    {
      label: "Korea (the Republic of)",
      value: WorldCountry.KOREA_SOUTH,
    },
    {
      label: "Kuwait",
      value: WorldCountry.KUWAIT,
    },
    {
      label: "Kyrgyzstan",
      value: WorldCountry.KYRGYZSTAN,
    },
    {
      label: "Lao People's Democratic Republic (the)",
      value: WorldCountry.LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    },
    {
      label: "Latvia",
      value: WorldCountry.LATVIA,
    },
    {
      label: "Lebanon",
      value: WorldCountry.LEBANON,
    },
    {
      label: "Lesotho",
      value: WorldCountry.LESOTHO,
    },
    {
      label: "Liberia",
      value: WorldCountry.LIBERIA,
    },
    {
      label: "Libya",
      value: WorldCountry.LIBYA,
    },
    {
      label: "Liechtenstein",
      value: WorldCountry.LIECHTENSTEIN,
    },
    {
      label: "Lithuania",
      value: WorldCountry.LITHUANIA,
    },
    {
      label: "Luxembourg",
      value: WorldCountry.LUXEMBOURG,
    },
    {
      label: "Macao",
      value: WorldCountry.MACAO,
    },
    {
      label: "Madagascar",
      value: WorldCountry.MADAGASCAR,
    },
    {
      label: "Malawi",
      value: WorldCountry.MALAWI,
    },
    {
      label: "Malaysia",
      value: WorldCountry.MALAYSIA,
    },
    {
      label: "Maldives",
      value: WorldCountry.MALDIVES,
    },
    {
      label: "Mali",
      value: WorldCountry.MALI,
    },
    {
      label: "Malta",
      value: WorldCountry.MALTA,
    },
    {
      label: "Marshall Islands (the)",
      value: WorldCountry.MARSHALL_ISLANDS,
    },
    {
      label: "Martinique",
      value: WorldCountry.MARTINIQUE,
    },
    {
      label: "Mauritania",
      value: WorldCountry.MAURITANIA,
    },
    {
      label: "Mauritius",
      value: WorldCountry.MAURITIUS,
    },
    {
      label: "Mayotte",
      value: WorldCountry.MAYOTTE,
    },
    {
      label: "Mexico",
      value: WorldCountry.MEXICO,
    },
    {
      label: "Micronesia (Federated States of)",
      value: WorldCountry.MICRONESIA,
    },
    {
      label: "Moldova (the Republic of)",
      value: WorldCountry.MOLDOVA,
    },
    {
      label: "Monaco",
      value: WorldCountry.MONACO,
    },
    {
      label: "Mongolia",
      value: WorldCountry.MONGOLIA,
    },
    {
      label: "Montenegro",
      value: WorldCountry.MONTENEGRO,
    },
    {
      label: "Montserrat",
      value: WorldCountry.MONTSERRAT,
    },
    {
      label: "Morocco",
      value: WorldCountry.MOROCCO,
    },
    {
      label: "Mozambique",
      value: WorldCountry.MOZAMBIQUE,
    },
    {
      label: "Myanmar",
      value: WorldCountry.MYANMAR,
    },
    {
      label: "Namibia",
      value: WorldCountry.NAMIBIA,
    },
    {
      label: "Nauru",
      value: WorldCountry.NAURU,
    },
    {
      label: "Nepal",
      value: WorldCountry.NEPAL,
    },
    {
      label: "Netherlands (the)",
      value: WorldCountry.NETHERLANDS,
    },
    {
      label: "Netherlands Antilles",
      value: WorldCountry.NETHERLANDS_ANTILLES,
    },
    {
      label: "New Caledonia",
      value: WorldCountry.NEW_CALEDONIA,
    },
    {
      label: "New Zealand",
      value: WorldCountry.NEW_ZEALAND,
    },
    {
      label: "Nicaragua",
      value: WorldCountry.NICARAGUA,
    },
    {
      label: "Niger (the)",
      value: WorldCountry.NIGER,
    },
    {
      label: "Nigeria",
      value: WorldCountry.NIGERIA,
    },
    {
      label: "Niue",
      value: WorldCountry.NIUE,
    },
    {
      label: "Norfolk Island",
      value: WorldCountry.NORFOLK_ISLAND,
    },
    {
      label: "Northern Mariana Islands (the)",
      value: WorldCountry.NORTHERN_MARIANA_ISLANDS,
    },
    {
      label: "Norway",
      value: WorldCountry.NORWAY,
    },
    {
      label: "Oman",
      value: WorldCountry.OMAN,
    },
    {
      label: "Pakistan",
      value: WorldCountry.PAKISTAN,
    },
    {
      label: "Palau",
      value: WorldCountry.PALAU,
    },
    {
      label: "Palestine, State of",
      value: WorldCountry.PALESTINE,
    },
    {
      label: "Panama",
      value: WorldCountry.PANAMA,
    },
    {
      label: "Papua New Guinea",
      value: WorldCountry.PAPUA_NEW_GUINEA,
    },
    {
      label: "Paraguay",
      value: WorldCountry.PARAGUAY,
    },
    {
      label: "Peru",
      value: WorldCountry.PERU,
    },
    {
      label: "Philippines (the)",
      value: WorldCountry.PHILIPPINES,
    },
    {
      label: "Pitcairn",
      value: WorldCountry.PITCAIRN,
    },
    {
      label: "Poland",
      value: WorldCountry.POLAND,
    },
    {
      label: "Portugal",
      value: WorldCountry.PORTUGAL,
    },
    {
      label: "Puerto Rico",
      value: WorldCountry.PUERTO_RICO,
    },
    {
      label: "Qatar",
      value: WorldCountry.QATAR,
    },
    {
      label: "Republic of North Macedonia",
      value: WorldCountry.REPUBLIC_OF_NORTH_MACEDONIA,
    },
    {
      label: "Romania",
      value: WorldCountry.ROMANIA,
    },
    {
      label: "Russian Federation (the)",
      value: WorldCountry.RUSSIAN_FEDERATION,
    },
    {
      label: "Rwanda",
      value: WorldCountry.RWANDA,
    },
    {
      label: "Réunion",
      value: WorldCountry.RÉUNION,
    },
    {
      label: "Saint Barthélemy",
      value: WorldCountry.SAINT_BARTHÉLEMY,
    },
    {
      label: "Saint Helena, Ascension and Tristan da Cunha",
      value: WorldCountry.SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA,
    },
    {
      label: "Saint Kitts and Nevis",
      value: WorldCountry.SAINT_KITTS_AND_NEVIS,
    },
    {
      label: "Saint Lucia",
      value: WorldCountry.SAINT_LUCIA,
    },
    {
      label: "Saint Martin (French part)",
      value: WorldCountry.SAINT_MARTIN,
    },
    {
      label: "Saint Pierre and Miquelon",
      value: WorldCountry.SAINT_PIERRE_AND_MIQUELON,
    },
    {
      label: "Saint Vincent and the Grenadines",
      value: WorldCountry.SAINT_VINCENT_AND_THE_GRENADINES,
    },
    {
      label: "Samoa",
      value: WorldCountry.SAMOA,
    },
    {
      label: "San Marino",
      value: WorldCountry.SAN_MARINO,
    },
    {
      label: "Sao Tome and Principe",
      value: WorldCountry.SAO_TOME_AND_PRINCIPE,
    },
    {
      label: "Saudi Arabia",
      value: WorldCountry.SAUDI_ARABIA,
    },
    {
      label: "Senegal",
      value: WorldCountry.SENEGAL,
    },
    {
      label: "Serbia",
      value: WorldCountry.SERBIA,
    },
    {
      label: "Seychelles",
      value: WorldCountry.SEYCHELLES,
    },
    {
      label: "Sierra Leone",
      value: WorldCountry.SIERRA_LEONE,
    },
    {
      label: "Singapore",
      value: WorldCountry.SINGAPORE,
    },
    {
      label: "Sint Maarten (Dutch part)",
      value: WorldCountry.SINT_MAARTEN,
    },
    {
      label: "Slovakia",
      value: WorldCountry.SLOVAKIA,
    },
    {
      label: "Slovenia",
      value: WorldCountry.SLOVENIA,
    },
    {
      label: "Solomon Islands",
      value: WorldCountry.SOLOMON_ISLANDS,
    },
    {
      label: "Somalia",
      value: WorldCountry.SOMALIA,
    },
    {
      label: "South Africa",
      value: WorldCountry.SOUTH_AFRICA,
    },
    {
      label: "South Georgia and the South Sandwich Islands",
      value: WorldCountry.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    },
    {
      label: "South Sudan",
      value: WorldCountry.SOUTH_SUDAN,
    },
    {
      label: "Spain",
      value: WorldCountry.SPAIN,
    },
    {
      label: "Sri Lanka",
      value: WorldCountry.SRI_LANKA,
    },
    {
      label: "Sudan (the)",
      value: WorldCountry.SUDAN,
    },
    {
      label: "Suriname",
      value: WorldCountry.SURINAME,
    },
    {
      label: "Svalbard and Jan Mayen",
      value: WorldCountry.SVALBARD_AND_JAN_MAYEN,
    },
    {
      label: "Sweden",
      value: WorldCountry.SWEDEN,
    },
    {
      label: "Switzerland",
      value: WorldCountry.SWITZERLAND,
    },
    {
      label: "Syrian Arab Republic",
      value: WorldCountry.SYRIAN_ARAB_REPUBLIC,
    },
    {
      label: "Taiwan (Province of China)",
      value: WorldCountry.TAIWAN,
    },
    {
      label: "Tajikistan",
      value: WorldCountry.TAJIKISTAN,
    },
    {
      label: "Tanzania, United Republic of",
      value: WorldCountry.TANZANIA_UNITED_REPUBLIC_OF,
    },
    {
      label: "Thailand",
      value: WorldCountry.THAILAND,
    },
    {
      label: "Timor-Leste",
      value: WorldCountry.TIMOR_LESTE,
    },
    {
      label: "Togo",
      value: WorldCountry.TOGO,
    },
    {
      label: "Tokelau",
      value: WorldCountry.TOKELAU,
    },
    {
      label: "Tonga",
      value: WorldCountry.TONGA,
    },
    {
      label: "Trinidad and Tobago",
      value: WorldCountry.TRINIDAD_AND_TOBAGO,
    },
    {
      label: "Tunisia",
      value: WorldCountry.TUNISIA,
    },
    {
      label: "Turkey",
      value: WorldCountry.TURKEY,
    },
    {
      label: "Turkmenistan",
      value: WorldCountry.TURKMENISTAN,
    },
    {
      label: "Turks and Caicos Islands (the)",
      value: WorldCountry.TURKS_AND_CAICOS_ISLANDS,
    },
    {
      label: "Tuvalu",
      value: WorldCountry.TUVALU,
    },
    {
      label: "Uganda",
      value: WorldCountry.UGANDA,
    },
    {
      label: "Ukraine",
      value: WorldCountry.UKRAINE,
    },
    {
      label: "United Arab Emirates (the)",
      value: WorldCountry.UNITED_ARAB_EMIRATES,
    },
    {
      label: "United Kingdom of Great Britain and Northern Ireland (the)",
      value: WorldCountry.UNITED_KINGDOM_OF_GREAT_BRITAIN_AND_NORTHERN_IRELAND,
    },
    {
      label: "United States Minor Outlying Islands (the)",
      value: WorldCountry.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    },
    {
      label: "United States of America (the)",
      value: WorldCountry.UNITED_STATES_OF_AMERICA,
    },
    {
      label: "Uruguay",
      value: WorldCountry.URUGUAY,
    },
    {
      label: "Uzbekistan",
      value: WorldCountry.UZBEKISTAN,
    },
    {
      label: "Vanuatu",
      value: WorldCountry.VANUATU,
    },
    {
      label: "Venezuela (Bolivarian Republic of)",
      value: WorldCountry.VENEZUELA,
    },
    {
      label: "Viet Nam",
      value: WorldCountry.VIET_NAM,
    },
    {
      label: "Virgin Islands (British)",
      value: WorldCountry.VIRGIN_ISLANDS_BRITISH,
    },
    {
      label: "Virgin Islands (U.S.)",
      value: WorldCountry.VIRGIN_ISLANDS,
    },
    {
      label: "Wallis and Futuna",
      value: WorldCountry.WALLIS_AND_FUTUNA,
    },
    {
      label: "Western Sahara",
      value: WorldCountry.WESTERN_SAHARA,
    },
    {
      label: "Yemen",
      value: WorldCountry.YEMEN,
    },
    {
      label: "Zambia",
      value: WorldCountry.ZAMBIA,
    },
    {
      label: "Zimbabwe",
      value: WorldCountry.ZIMBABWE,
    },
    {
      label: "Åland Islands",
      value: WorldCountry.ÅLAND_ISLANDS,
    },
  ],
  de: [
    {
      label: "Deutschland",
      value: WorldCountry.GERMANY,
    },
    {
      label: "Frankreich",
      value: WorldCountry.FRANCE,
    },
    {
      label: "Schweiz",
      value: WorldCountry.SWITZERLAND,
    },
    {
      label: "Österreich",
      value: WorldCountry.AUSTRIA,
    },
    {
      label: "Afghanistan",
      value: WorldCountry.AFGHANISTAN,
    },
    {
      label: "Albanien",
      value: WorldCountry.ALBANIA,
    },
    {
      label: "Algerien",
      value: WorldCountry.ALGERIA,
    },
    {
      label: "Amerikanischen Samoa-Inseln",
      value: WorldCountry.AMERICAN_SAMOA,
    },
    {
      label: "Andorra",
      value: WorldCountry.ANDORRA,
    },
    {
      label: "Angola",
      value: WorldCountry.ANGOLA,
    },
    {
      label: "Anguilla",
      value: WorldCountry.ANGUILLA,
    },
    {
      label: "Antarktis",
      value: WorldCountry.ANTARCTICA,
    },
    {
      label: "Antigua und Barbuda",
      value: WorldCountry.ANTIGUA_AND_BARBUDA,
    },
    {
      label: "Argentinien",
      value: WorldCountry.ARGENTINA,
    },
    {
      label: "Armenien",
      value: WorldCountry.ARMENIA,
    },
    {
      label: "Aruba",
      value: WorldCountry.ARUBA,
    },
    {
      label: "Australien",
      value: WorldCountry.AUSTRALIA,
    },
    {
      label: "Aserbaidschan",
      value: WorldCountry.AZERBAIJAN,
    },
    {
      label: "Bahamas (die)",
      value: WorldCountry.BAHAMAS,
    },
    {
      label: "Bahrain",
      value: WorldCountry.BAHRAIN,
    },
    {
      label: "Bangladesch",
      value: WorldCountry.BANGLADESH,
    },
    {
      label: "Barbados",
      value: WorldCountry.BARBADOS,
    },
    {
      label: "Weißrussland",
      value: WorldCountry.BELARUS,
    },
    {
      label: "Belgien",
      value: WorldCountry.BELGIUM,
    },
    {
      label: "Belize",
      value: WorldCountry.BELIZE,
    },
    {
      label: "Benin",
      value: WorldCountry.BENIN,
    },
    {
      label: "Bermuda",
      value: WorldCountry.BERMUDA,
    },
    {
      label: "Bhutan",
      value: WorldCountry.BHUTAN,
    },
    {
      label: "Bolivien (plurinationaler Staat)",
      value: WorldCountry.BOLIVIA,
    },
    {
      label: "Bonaire, Sint Eustatius und Saba",
      value: WorldCountry.BONAIRE_SINT_EUSTATIUS_AND_SABA,
    },
    {
      label: "Bosnien und Herzegowina",
      value: WorldCountry.BOSNIA_AND_HERZEGOVINA,
    },
    {
      label: "Botswana",
      value: WorldCountry.BOTSWANA,
    },
    {
      label: "Bouvet-Insel",
      value: WorldCountry.BOUVET_ISLAND,
    },
    {
      label: "Brasilien",
      value: WorldCountry.BRAZIL,
    },
    {
      label: "British Indian Ocean Territory (the)",
      value: WorldCountry.BRITISH_INDIAN_OCEAN_TERRITORY,
    },
    {
      label: "Brunei Darussalam",
      value: WorldCountry.BRUNEI_DARUSSALAM,
    },
    {
      label: "Bulgarien",
      value: WorldCountry.BULGARIA,
    },
    {
      label: "Burkina Faso",
      value: WorldCountry.BURKINA_FASO,
    },
    {
      label: "Burundi",
      value: WorldCountry.BURUNDI,
    },
    {
      label: "Cabo Verde",
      value: WorldCountry.CABO_VERDE,
    },
    {
      label: "Kambodscha",
      value: WorldCountry.CAMBODIA,
    },
    {
      label: "Kamerun",
      value: WorldCountry.CAMEROON,
    },
    {
      label: "Kanada",
      value: WorldCountry.CANADA,
    },
    {
      label: "Cayman Islands (the)",
      value: WorldCountry.CAYMAN_ISLANDS,
    },
    {
      label: "Zentralafrikanische Republik (die)",
      value: WorldCountry.CENTRAL_AFRICAN_REPUBLIC,
    },
    {
      label: "Tschad",
      value: WorldCountry.CHAD,
    },
    {
      label: "Chile",
      value: WorldCountry.CHILE,
    },
    {
      label: "China",
      value: WorldCountry.CHINA,
    },
    {
      label: "Weihnachtsinsel",
      value: WorldCountry.CHRISTMAS_ISLAND,
    },
    {
      label: "Cocos (Keeling) Islands (the)",
      value: WorldCountry.COCOS_ISLANDS,
    },
    {
      label: "Kolumbien",
      value: WorldCountry.COLOMBIA,
    },
    {
      label: "Komoren (der)",
      value: WorldCountry.COMOROS,
    },
    {
      label: "Kongo (Demokratische Republik)",
      value: WorldCountry.CONGO,
    },
    {
      label: "Kongo (der)",
      value: WorldCountry.CONGO_2,
    },
    {
      label: "Cook Islands (die)",
      value: WorldCountry.COOK_ISLANDS,
    },
    {
      label: "Costa Rica",
      value: WorldCountry.COSTA_RICA,
    },
    {
      label: "Kroatien",
      value: WorldCountry.CROATIA,
    },
    {
      label: "Kuba",
      value: WorldCountry.CUBA,
    },
    {
      label: "Curaçao",
      value: WorldCountry.CURAÇAO,
    },
    {
      label: "Zypern",
      value: WorldCountry.CYPRUS,
    },
    {
      label: "Tschechien",
      value: WorldCountry.CZECHIA,
    },
    {
      label: "Côte d'Ivoire",
      value: WorldCountry.CÔTE_D_IVOIRE,
    },
    {
      label: "Dänemark",
      value: WorldCountry.DENMARK,
    },
    {
      label: "Dschibuti",
      value: WorldCountry.DJIBOUTI,
    },
    {
      label: "Dominica",
      value: WorldCountry.DOMINICA,
    },
    {
      label: "Dominikanische Republik (die)",
      value: WorldCountry.DOMINICAN_REPUBLIC,
    },
    {
      label: "Ecuador",
      value: WorldCountry.ECUADOR,
    },
    {
      label: "Ägypten",
      value: WorldCountry.EGYPT,
    },
    {
      label: "El Salvador",
      value: WorldCountry.EL_SALVADOR,
    },
    {
      label: "Äquatorialguinea",
      value: WorldCountry.EQUATORIAL_GUINEA,
    },
    {
      label: "Eritrea",
      value: WorldCountry.ERITREA,
    },
    {
      label: "Estland",
      value: WorldCountry.ESTONIA,
    },
    {
      label: "Eswatini",
      value: WorldCountry.ESWATINI,
    },
    {
      label: "Äthiopien",
      value: WorldCountry.ETHIOPIA,
    },
    {
      label: "Falkland-Inseln (die) [Malvinas]",
      value: WorldCountry.FALKLAND_ISLANDS,
    },
    {
      label: "Färöer (die)",
      value: WorldCountry.FAROE_ISLANDS,
    },
    {
      label: "Fidschi",
      value: WorldCountry.FIJI,
    },
    {
      label: "Finnland",
      value: WorldCountry.FINLAND,
    },
    {
      label: "Französisch-Guayana",
      value: WorldCountry.FRENCH_GUIANA,
    },
    {
      label: "Französisch-Polynesien",
      value: WorldCountry.FRENCH_POLYNESIA,
    },
    {
      label: "Französische Südterritorien (die)",
      value: WorldCountry.FRENCH_SOUTHERN_TERRITORIES,
    },
    {
      label: "Gabun",
      value: WorldCountry.GABON,
    },
    {
      label: "Gambia (der)",
      value: WorldCountry.GAMBIA,
    },
    {
      label: "Georgien",
      value: WorldCountry.GEORGIA,
    },
    {
      label: "Ghana",
      value: WorldCountry.GHANA,
    },
    {
      label: "Gibraltar",
      value: WorldCountry.GIBRALTAR,
    },
    {
      label: "Griechenland",
      value: WorldCountry.GREECE,
    },
    {
      label: "Grönland",
      value: WorldCountry.GREENLAND,
    },
    {
      label: "Grenada",
      value: WorldCountry.GRENADA,
    },
    {
      label: "Guadeloupe",
      value: WorldCountry.GUADELOUPE,
    },
    {
      label: "Guam",
      value: WorldCountry.GUAM,
    },
    {
      label: "Guatemala",
      value: WorldCountry.GUATEMALA,
    },
    {
      label: "Guernsey",
      value: WorldCountry.GUERNSEY,
    },
    {
      label: "Guinea",
      value: WorldCountry.GUINEA,
    },
    {
      label: "Guinea-Bissau",
      value: WorldCountry.GUINEA_BISSAU,
    },
    {
      label: "Guyana",
      value: WorldCountry.GUYANA,
    },
    {
      label: "Haiti",
      value: WorldCountry.HAITI,
    },
    {
      label: "Heard Island und McDonald Islands",
      value: WorldCountry.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    },
    {
      label: "Heiliger Stuhl (der)",
      value: WorldCountry.HOLY_SEE,
    },
    {
      label: "Honduras",
      value: WorldCountry.HONDURAS,
    },
    {
      label: "Hongkong",
      value: WorldCountry.HONG_KONG,
    },
    {
      label: "Ungarn",
      value: WorldCountry.HUNGARY,
    },
    {
      label: "Island",
      value: WorldCountry.ICELAND,
    },
    {
      label: "Indien",
      value: WorldCountry.INDIA,
    },
    {
      label: "Indonesien",
      value: WorldCountry.INDONESIA,
    },
    {
      label: "Iran (Islamische Republik)",
      value: WorldCountry.IRAN,
    },
    {
      label: "Irak",
      value: WorldCountry.IRAQ,
    },
    {
      label: "Irland",
      value: WorldCountry.IRELAND,
    },
    {
      label: "Isle of Man",
      value: WorldCountry.ISLE_OF_MAN,
    },
    {
      label: "Israel",
      value: WorldCountry.ISRAEL,
    },
    {
      label: "Italien",
      value: WorldCountry.ITALY,
    },
    {
      label: "Jamaika",
      value: WorldCountry.JAMAICA,
    },
    {
      label: "Japan",
      value: WorldCountry.JAPAN,
    },
    {
      label: "Trikot",
      value: WorldCountry.JERSEY,
    },
    {
      label: "Jordanien",
      value: WorldCountry.JORDAN,
    },
    {
      label: "Kasachstan",
      value: WorldCountry.KAZAKHSTAN,
    },
    {
      label: "Kenia",
      value: WorldCountry.KENYA,
    },
    {
      label: "Kiribati",
      value: WorldCountry.KIRIBATI,
    },
    {
      label: "Korea (die Demokratische Volksrepublik)",
      value: WorldCountry.KOREA_NORTH,
    },
    {
      label: "Korea (Republik)",
      value: WorldCountry.KOREA_SOUTH,
    },
    {
      label: "Kuwait",
      value: WorldCountry.KUWAIT,
    },
    {
      label: "Kirgisistan",
      value: WorldCountry.KYRGYZSTAN,
    },
    {
      label: "Laotische Demokratische Volksrepublik (die)",
      value: WorldCountry.LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
    },
    {
      label: "Lettland",
      value: WorldCountry.LATVIA,
    },
    {
      label: "Libanon",
      value: WorldCountry.LEBANON,
    },
    {
      label: "Lesotho",
      value: WorldCountry.LESOTHO,
    },
    {
      label: "Liberia",
      value: WorldCountry.LIBERIA,
    },
    {
      label: "Libyen",
      value: WorldCountry.LIBYA,
    },
    {
      label: "Liechtenstein",
      value: WorldCountry.LIECHTENSTEIN,
    },
    {
      label: "Litauen",
      value: WorldCountry.LITHUANIA,
    },
    {
      label: "Luxemburg",
      value: WorldCountry.LUXEMBOURG,
    },
    {
      label: "Macau",
      value: WorldCountry.MACAO,
    },
    {
      label: "Madagaskar",
      value: WorldCountry.MADAGASCAR,
    },
    {
      label: "Malawi",
      value: WorldCountry.MALAWI,
    },
    {
      label: "Malaysia",
      value: WorldCountry.MALAYSIA,
    },
    {
      label: "Malediven",
      value: WorldCountry.MALDIVES,
    },
    {
      label: "Mali",
      value: WorldCountry.MALI,
    },
    {
      label: "Malta",
      value: WorldCountry.MALTA,
    },
    {
      label: "Marshall-Inseln (die)",
      value: WorldCountry.MARSHALL_ISLANDS,
    },
    {
      label: "Martinique",
      value: WorldCountry.MARTINIQUE,
    },
    {
      label: "Mauretanien",
      value: WorldCountry.MAURITANIA,
    },
    {
      label: "Mauritius",
      value: WorldCountry.MAURITIUS,
    },
    {
      label: "Mayotte",
      value: WorldCountry.MAYOTTE,
    },
    {
      label: "Mexiko",
      value: WorldCountry.MEXICO,
    },
    {
      label: "Mikronesien (Föderierte Staaten von)",
      value: WorldCountry.MICRONESIA,
    },
    {
      label: "Moldawien (Republik)",
      value: WorldCountry.MOLDOVA,
    },
    {
      label: "Monaco",
      value: WorldCountry.MONACO,
    },
    {
      label: "Mongolei",
      value: WorldCountry.MONGOLIA,
    },
    {
      label: "Montenegro",
      value: WorldCountry.MONTENEGRO,
    },
    {
      label: "Montserrat",
      value: WorldCountry.MONTSERRAT,
    },
    {
      label: "Marokko",
      value: WorldCountry.MOROCCO,
    },
    {
      label: "Mosambik",
      value: WorldCountry.MOZAMBIQUE,
    },
    {
      label: "Myanmar",
      value: WorldCountry.MYANMAR,
    },
    {
      label: "Namibia",
      value: WorldCountry.NAMIBIA,
    },
    {
      label: "Nauru",
      value: WorldCountry.NAURU,
    },
    {
      label: "Nepal",
      value: WorldCountry.NEPAL,
    },
    {
      label: "Niederlande (die)",
      value: WorldCountry.NETHERLANDS,
    },
    {
      label: "Niederländische Antillen",
      value: WorldCountry.NETHERLANDS_ANTILLES,
    },
    {
      label: "Neukaledonien",
      value: WorldCountry.NEW_CALEDONIA,
    },
    {
      label: "Neuseeland",
      value: WorldCountry.NEW_ZEALAND,
    },
    {
      label: "Nicaragua",
      value: WorldCountry.NICARAGUA,
    },
    {
      label: "Niger (der)",
      value: WorldCountry.NIGER,
    },
    {
      label: "Nigeria",
      value: WorldCountry.NIGERIA,
    },
    {
      label: "Niue",
      value: WorldCountry.NIUE,
    },
    {
      label: "Norfolkinsel",
      value: WorldCountry.NORFOLK_ISLAND,
    },
    {
      label: "Nördliche Marianen (die)",
      value: WorldCountry.NORTHERN_MARIANA_ISLANDS,
    },
    {
      label: "Norwegen",
      value: WorldCountry.NORWAY,
    },
    {
      label: "Oman",
      value: WorldCountry.OMAN,
    },
    {
      label: "Pakistan",
      value: WorldCountry.PAKISTAN,
    },
    {
      label: "Palau",
      value: WorldCountry.PALAU,
    },
    {
      label: "Palästina, Bundesstaat",
      value: WorldCountry.PALESTINE,
    },
    {
      label: "Panama",
      value: WorldCountry.PANAMA,
    },
    {
      label: "Papua-Neuguinea",
      value: WorldCountry.PAPUA_NEW_GUINEA,
    },
    {
      label: "Paraguay",
      value: WorldCountry.PARAGUAY,
    },
    {
      label: "Peru",
      value: WorldCountry.PERU,
    },
    {
      label: "Philippinen (die)",
      value: WorldCountry.PHILIPPINES,
    },
    {
      label: "Pitcairn",
      value: WorldCountry.PITCAIRN,
    },
    {
      label: "Polen",
      value: WorldCountry.POLAND,
    },
    {
      label: "Portugal",
      value: WorldCountry.PORTUGAL,
    },
    {
      label: "Puerto Rico",
      value: WorldCountry.PUERTO_RICO,
    },
    {
      label: "Katar",
      value: WorldCountry.QATAR,
    },
    {
      label: "Republik Nordmazedonien",
      value: WorldCountry.REPUBLIC_OF_NORTH_MACEDONIA,
    },
    {
      label: "Rumänien",
      value: WorldCountry.ROMANIA,
    },
    {
      label: "Russische Föderation (die)",
      value: WorldCountry.RUSSIAN_FEDERATION,
    },
    {
      label: "Ruanda",
      value: WorldCountry.RWANDA,
    },
    {
      label: "Réunion",
      value: WorldCountry.RÉUNION,
    },
    {
      label: "Saint Barthélemy",
      value: WorldCountry.SAINT_BARTHÉLEMY,
    },
    {
      label: "Heilige Helena, Himmelfahrt und Tristan da Cunha",
      value: WorldCountry.SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA,
    },
    {
      label: "St. Kitts und Nevis",
      value: WorldCountry.SAINT_KITTS_AND_NEVIS,
    },
    {
      label: "Heilige Lucia",
      value: WorldCountry.SAINT_LUCIA,
    },
    {
      label: "Saint Martin (französischer Teil)",
      value: WorldCountry.SAINT_MARTIN,
    },
    {
      label: "Saint Pierre und Miquelon",
      value: WorldCountry.SAINT_PIERRE_AND_MIQUELON,
    },
    {
      label: "St. Vincent und die Grenadinen",
      value: WorldCountry.SAINT_VINCENT_AND_THE_GRENADINES,
    },
    {
      label: "Samoa",
      value: WorldCountry.SAMOA,
    },
    {
      label: "San Marino",
      value: WorldCountry.SAN_MARINO,
    },
    {
      label: "Sao Tome und Principe",
      value: WorldCountry.SAO_TOME_AND_PRINCIPE,
    },
    {
      label: "Saudi-Arabien",
      value: WorldCountry.SAUDI_ARABIA,
    },
    {
      label: "Senegal",
      value: WorldCountry.SENEGAL,
    },
    {
      label: "Serbien",
      value: WorldCountry.SERBIA,
    },
    {
      label: "Seychellen",
      value: WorldCountry.SEYCHELLES,
    },
    {
      label: "Sierra Leone",
      value: WorldCountry.SIERRA_LEONE,
    },
    {
      label: "Singapur",
      value: WorldCountry.SINGAPORE,
    },
    {
      label: "Sint Maarten (Niederländischer Teil)",
      value: WorldCountry.SINT_MAARTEN,
    },
    {
      label: "Slowakei",
      value: WorldCountry.SLOVAKIA,
    },
    {
      label: "Slowenien",
      value: WorldCountry.SLOVENIA,
    },
    {
      label: "Salomonen",
      value: WorldCountry.SOLOMON_ISLANDS,
    },
    {
      label: "Somalia",
      value: WorldCountry.SOMALIA,
    },
    {
      label: "Südafrika",
      value: WorldCountry.SOUTH_AFRICA,
    },
    {
      label: "Südgeorgien und die Südlichen Sandwichinseln",
      value: WorldCountry.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    },
    {
      label: "Südsudan",
      value: WorldCountry.SOUTH_SUDAN,
    },
    {
      label: "Spanien",
      value: WorldCountry.SPAIN,
    },
    {
      label: "Sri Lanka",
      value: WorldCountry.SRI_LANKA,
    },
    {
      label: "Sudan (der)",
      value: WorldCountry.SUDAN,
    },
    {
      label: "Suriname",
      value: WorldCountry.SURINAME,
    },
    {
      label: "Svalbard und Jan Mayen",
      value: WorldCountry.SVALBARD_AND_JAN_MAYEN,
    },
    {
      label: "Schweden",
      value: WorldCountry.SWEDEN,
    },
    {
      label: "Syrische Arabische Republik",
      value: WorldCountry.SYRIAN_ARAB_REPUBLIC,
    },
    {
      label: "Taiwan (Provinz China)",
      value: WorldCountry.TAIWAN,
    },
    {
      label: "Tadschikistan",
      value: WorldCountry.TAJIKISTAN,
    },
    {
      label: "Tansania, Vereinigte Republik",
      value: WorldCountry.TANZANIA_UNITED_REPUBLIC_OF,
    },
    {
      label: "Thailand",
      value: WorldCountry.THAILAND,
    },
    {
      label: "Timor-Leste",
      value: WorldCountry.TIMOR_LESTE,
    },
    {
      label: "Togo",
      value: WorldCountry.TOGO,
    },
    {
      label: "Tokelau",
      value: WorldCountry.TOKELAU,
    },
    {
      label: "Tonga",
      value: WorldCountry.TONGA,
    },
    {
      label: "Trinidad und Tobago",
      value: WorldCountry.TRINIDAD_AND_TOBAGO,
    },
    {
      label: "Tunesien",
      value: WorldCountry.TUNISIA,
    },
    {
      label: "Türkei",
      value: WorldCountry.TURKEY,
    },
    {
      label: "Turkmenistan",
      value: WorldCountry.TURKMENISTAN,
    },
    {
      label: "Turks and Caicos Islands (the)",
      value: WorldCountry.TURKS_AND_CAICOS_ISLANDS,
    },
    {
      label: "Tuvalu",
      value: WorldCountry.TUVALU,
    },
    {
      label: "Uganda",
      value: WorldCountry.UGANDA,
    },
    {
      label: "Ukraine",
      value: WorldCountry.UKRAINE,
    },
    {
      label: "Vereinigte Arabische Emirate (die)",
      value: WorldCountry.UNITED_ARAB_EMIRATES,
    },
    {
      label: "Vereinigtes Königreich Großbritannien und Nordirland (the)",
      value: WorldCountry.UNITED_KINGDOM_OF_GREAT_BRITAIN_AND_NORTHERN_IRELAND,
    },
    {
      label: "Mindere vorgelagerte Inseln der Vereinigten Staaten (die)",
      value: WorldCountry.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
    },
    {
      label: "Vereinigte Staaten von Amerika (die)",
      value: WorldCountry.UNITED_STATES_OF_AMERICA,
    },
    {
      label: "Uruguay",
      value: WorldCountry.URUGUAY,
    },
    {
      label: "Usbekistan",
      value: WorldCountry.UZBEKISTAN,
    },
    {
      label: "Vanuatu",
      value: WorldCountry.VANUATU,
    },
    {
      label: "Venezuela (Bolivarische Republik)",
      value: WorldCountry.VENEZUELA,
    },
    {
      label: "Vietnam",
      value: WorldCountry.VIET_NAM,
    },
    {
      label: "Virgin Islands (British)",
      value: WorldCountry.VIRGIN_ISLANDS_BRITISH,
    },
    {
      label: "Virgin Islands (U.S.)",
      value: WorldCountry.VIRGIN_ISLANDS,
    },
    {
      label: "Wallis und Futuna",
      value: WorldCountry.WALLIS_AND_FUTUNA,
    },
    {
      label: "Westsahara",
      value: WorldCountry.WESTERN_SAHARA,
    },
    {
      label: "Jemen",
      value: WorldCountry.JERSEY,
    },
    {
      label: "Sambia",
      value: WorldCountry.ZAMBIA,
    },
    {
      label: "Simbabwe",
      value: WorldCountry.ZIMBABWE,
    },
    {
      label: "Åland-Inseln",
      value: WorldCountry.ÅLAND_ISLANDS,
    },
  ],
};
